import Vue from 'vue'
// eslint-disable-next-line import/no-duplicates
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import less from 'less'
import api from './config/apiConfig'
import commonFuc from './commonFunctions/commonFunctions'
import '../theme/index.css'
import './assets/style/common.css'
import router from './router'
import App from './App'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import store from './store/index'
import 'element-ui/lib/theme-chalk/base.css'
// eslint-disable-next-line import/no-duplicates
import { Message } from 'element-ui'
import toastRegistry from './components/myToast'
import noticeRegistry from './components/noticeDialog.js'
import echarts from 'echarts'
import slideVerify from 'vue-monoplasty-slide-verify'
Vue.use(ElementUI)
Vue.use(less)
Vue.use(toastRegistry)
Vue.use(noticeRegistry)
Vue.use(slideVerify)
/* eslint-disable no-new */
Vue.prototype.$api = api
Vue.prototype.$message = Message
Vue.use(ElementUI, { size: 'middle' })
Vue.prototype.$commonFuc = commonFuc
Vue.prototype.$echarts = echarts
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999,
    inline: false,
    button: true,
    navbar: false,
    title: false,
    loop: true,
    toolbar: {
      zoomIn: 1,
      zoomOut: 1,
      oneToOne: 0,
      reset: 0,
      prev: 0,
      play: {
        show: 0,
        size: 'large'
      },
      // eslint-disable-next-line no-dupe-keys
      prev: 1,
      next: 1,
      rotateLeft: 1,
      rotateRight: 1,
      flipHorizontal: 1,
      flipVertical: 1
    },
    tooltip: true,
    movable: true,
    zoomable: true,
    rotatable: true,
    scalable: true,
    transition: true,
    fullscreen: false,
    keyboard: false
  }
})
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js